import React, { useEffect } from 'react';
import './About.css';
import Discliamber from './Discliamer'
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';


export default function About() {



  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <>
     <div><Navbar /></div>
    
    
    
    <section id="home-appliance-repair-service">
  <div class="service-header">
    <h2>Expert Home Appliance Repair Services</h2>
    <p>Providing top-quality, reliable, and affordable repair solutions for your household appliances. Our expert technicians are here to restore your comfort and convenience with fast, professional service. Whether it's your washing machine, fridge, TV, microwave oven, water heater, or water purifier, we’ve got you covered!</p>
  </div>
  
  <div class="service-list">
    <div class="service-item">
      <h3>Washing Machine Repair</h3>
      <p>Is your washing machine making strange noises or not working properly? Our skilled technicians specialize in all brands and models, ensuring quick repairs that restore your washing machine's functionality. From faulty motors to drainage issues, we handle it all!</p>
    </div>
    
    <div class="service-item">
      <h3>Fridge Repair</h3>
      <p>A malfunctioning fridge can lead to spoiled food and unnecessary inconvenience. Our expert fridge repair services include fixing temperature issues, leakages, and compressor problems. We aim to get your fridge working smoothly so you can keep your food fresh and safe!</p>
    </div>
    
    <div class="service-item">
      <h3>TV Repair</h3>
      <p>Is your TV screen flickering, or does it fail to turn on? We offer comprehensive TV repair services for all major brands. Our technicians can diagnose screen issues, audio problems, and other technical faults to ensure your TV is up and running in no time.</p>
    </div>

    <div class="service-item">
      <h3>Microwave Oven Repair</h3>
      <p>Microwave ovens are essential in modern kitchens, and when they break down, it can be a huge inconvenience. Our technicians are well-equipped to repair all kinds of microwave ovens, from simple problems like a malfunctioning door switch to complex issues with the microwave's electrical systems.</p>
    </div>

    <div class="service-item">
      <h3>Water Heater Repair</h3>
      <p>Don't let a broken water heater leave you in the cold. Whether it's water not heating up, strange noises, or water leakage, we offer prompt and efficient water heater repair services. Our professionals can diagnose the issue and ensure you have access to hot water again quickly.</p>
    </div>
    
    <div class="service-item">
      <h3>Water Purifier Repair</h3>
      <p>Clean water is essential for your health, and a faulty water purifier can compromise that. Our water purifier repair service ensures that your system works properly by fixing issues like filter replacements, leakage, and performance problems. Stay healthy with our reliable repair solutions!</p>
    </div>
  </div>

  <div class="why-choose-us">
    <h3>Why Choose Us?</h3>
    <ul>
      <li>Experienced and certified technicians</li>
      <li>Fast and reliable service</li>
      <li>Affordable pricing with no hidden fees</li>
      <li>Repairs for all major appliance brands</li>
      <li>Customer satisfaction guaranteed</li>
    </ul>
  </div>

  <div class="call-to-action">
    <h3>Contact Us Today for Expert Appliance Repair!</h3>
    <p>Don’t let appliance issues disrupt your day. Get in touch with us for prompt, professional repair services. Our team is available for service calls and consultations. We're just a phone call away!</p>
    <a hre="tel:+919876543210"><button class="cta-button">Call Now</button></a>
  </div>
</section>
<div><Discliamber/></div>
      <div><Footer /></div>
    
    
    
    
    </>
  )
}
